export const iconFontAwesomeTransportationTruckMedical = (
	<i className="fa-solid fa-truck-medical"></i>
);
